/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersResponse } from '../../models/users-response';

export interface GetAllResellerUsers$Params {

/**
 * The first name of the user
 */
  firstName?: string;

/**
 * The last name of the user
 */
  lastName?: string;

/**
 * The external flag of the user
 */
  external?: boolean;

/**
 * The user's email.
 */
  email?: string;

/**
 * The user's phone number (searchable by exact match).
 */
  phoneNumber?: string;

/**
 * The user's status. Possible values: 'active', 'invited', 'disabled'.
 */
  status?: 'active' | 'invited' | 'disabled';

/**
 * The role id to filter.
 */
  roleId?: string;

/**
 * Reseller identifier to filter
 */
  resellerId?: string;

/**
 * Number of results per call. Accepted values: 0 - 1000 / Default 100 / Recommended 50.
 */
  size?: number;

/**
 * This property is used to specify the initial point (page #) for each page to start searching the record in the index (OFFSET). Means it specifies from which record in an index should start searching.
 */
  start?: string;

/**
 * The field used to sort the retults (only one field is supported for sorting). To sort on entityAttributes use dot notation: `entityAttributes.storeName`
 */
  sortField?: string;

/**
 * Determines the order direction for sorted results. Possible values: 'asc' or 'desc'.
 */
  sortDir?: 'asc' | 'desc';
}

export function getAllResellerUsers(http: HttpClient, rootUrl: string, params?: GetAllResellerUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersResponse>> {
  const rb = new RequestBuilder(rootUrl, getAllResellerUsers.PATH, 'get');
  if (params) {
    rb.query('firstName', params.firstName, {});
    rb.query('lastName', params.lastName, {});
    rb.query('external', params.external, {});
    rb.query('email', params.email, {});
    rb.query('phoneNumber', params.phoneNumber, {});
    rb.query('status', params.status, {});
    rb.query('roleId', params.roleId, {});
    rb.query('resellerId', params.resellerId, {});
    rb.query('size', params.size, {});
    rb.query('start', params.start, {});
    rb.query('sortField', params.sortField, {});
    rb.query('sortDir', params.sortDir, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsersResponse>;
    })
  );
}

getAllResellerUsers.PATH = '/resellers/users';
